module.exports = __webpack_public_path__ + "img/collection-engagementRingsTensionRing@2x.0135e80.jpg";